/// <reference path="../svg.d.ts" />
import React from 'react';
import {
  BadgeCheck,
  Mail,
  Phone,
  Plus,
  ArrowRight,
  ArrowLeft,
  ArrowUpRight,
  Calendar,
  XCircle,
  Info,
  Truck,
  X,
  RefreshCcw,
  Loader,
  MoreVertical,
  FileText,
  Download,
  AlertCircle,
  Star,
  Pencil,
  ImageOff,
  TrendingUp,
  TrendingDown,
  Minus,
  Eye,
  Trash2,
  Zap,
  CircleCheck,
  Expand,
  Upload,
  LogOut,
  Globe,
  ChevronDown,
  PowerOff,
  Wrench,
  Hourglass,
  Search,
  Filter,
  Handshake,
  Sparkles,
  Lock,
  Headphones,
  Target,
  MessageCircle,
  MessageSquare,
  Send,
  Bot,
  Mic,
  Paperclip,
  CheckCheck,
  Ban,
} from 'lucide-react';
import { getIconProps, IconProps } from '../utils';

export const PhoneIcon: React.FC<IconProps> = props => {
  return <Phone {...getIconProps(props)} />;
};

/** Customer-support / help-desk affordance (contact lender, support CTA). */
export const SupportIcon: React.FC<IconProps> = props => {
  return <Headphones {...getIconProps(props)} />;
};

export const MailIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Mail {...iconProps} />;
};

export const PlusIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Plus {...iconProps} />;
};

export const ArrowRightIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <ArrowRight {...iconProps} />;
};

export const ArrowLeftIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <ArrowLeft {...iconProps} />;
};

export const ArrowUpRightIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <ArrowUpRight {...iconProps} />;
};

export const CalendarIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Calendar {...iconProps} />;
};

export const ClearIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <XCircle {...iconProps} />;
};

export const InfoIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Info {...iconProps} />;
};

export const TruckIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Truck {...iconProps} />;
};

export const CloseIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <X {...iconProps} />;
};

export const RefreshIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <RefreshCcw {...iconProps} />;
};

export const LoaderIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Loader {...iconProps} />;
};

export const MoreVerticalIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <MoreVertical {...iconProps} />;
};

export const FileTextIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <FileText {...iconProps} />;
};

export const DownloadIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Download {...iconProps} />;
};

export const AlertCircleIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <AlertCircle {...iconProps} />;
};

export const StarIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Star {...iconProps} />;
};

export const PencilIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Pencil {...iconProps} />;
};

export const ImageOffIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <ImageOff {...iconProps} />;
};

export const TrendingUpIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <TrendingUp {...iconProps} />;
};

export const TrendingDownIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <TrendingDown {...iconProps} />;
};

export const MinusIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Minus {...iconProps} />;
};

export const EyeIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Eye {...iconProps} />;
};

export const TrashIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Trash2 {...iconProps} />;
};

export const ZapIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Zap {...iconProps} />;
};

export const SparklesIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Sparkles {...iconProps} />;
};

export const LockIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Lock {...iconProps} />;
};

export const CircleCheckIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <CircleCheck {...iconProps} />;
};

/** A verified / proven value — see `FieldVerification`. */
export const BadgeCheckIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <BadgeCheck {...iconProps} />;
};

export const ExpandIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Expand {...iconProps} />;
};

export const UploadIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Upload {...iconProps} />;
};

export const LogOutIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <LogOut {...iconProps} />;
};

export const GlobeIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Globe {...iconProps} />;
};

export const ChevronDownIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <ChevronDown {...iconProps} />;
};

export const PowerOffIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <PowerOff {...iconProps} />;
};

export const WrenchIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Wrench {...iconProps} />;
};

export const HourglassIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Hourglass {...iconProps} />;
};

/** A message that was composed but deliberately never sent. */
export const WithheldIcon: React.FC<IconProps> = props => {
  return <Ban {...getIconProps(props)} />;
};

export const SearchIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Search {...iconProps} />;
};

export const RefreshCcwIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <RefreshCcw {...iconProps} />;
};

export const FilterIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Filter {...iconProps} />;
};

export const XIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <X {...iconProps} />;
};

/**
 * Broker / handshake icon.
 *
 * Used by the `ClientRoleSelector` to represent the `broker`
 * `partyRoleSchema` value. Hero is a network, not a marketplace —
 * brokers are first-class participants on either side of any
 * relationship.
 */
export const BrokerIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Handshake {...iconProps} />;
};

/**
 * Bullseye / target icon.
 *
 * Used by the publish-order `CarrierSection` for the
 * "Specific carrier" allocation tile — pick a single recipient
 * Org/Client instead of broadcasting.
 */
export const TargetIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <Target {...iconProps} />;
};

/** Chat bubble — used by the agent chat launcher FAB. */
export const MessageCircleIcon: React.FC<IconProps> = props => (
  <MessageCircle {...getIconProps(props)} />
);

export const MessageSquareIcon: React.FC<IconProps> = props => (
  <MessageSquare {...getIconProps(props)} />
);

/** Paper-plane — used by the chat composer's Send button. */
export const SendIcon: React.FC<IconProps> = props => (
  <Send {...getIconProps(props)} />
);

/** Bot avatar — used for AI-authored chat bubbles. */
export const BotIcon: React.FC<IconProps> = props => (
  <Bot {...getIconProps(props)} />
);

/** Mic — composer voice-input affordance (Phase 2). */
export const MicIcon: React.FC<IconProps> = props => (
  <Mic {...getIconProps(props)} />
);

/** Paperclip — composer attachment affordance (Phase 2). */
export const PaperclipIcon: React.FC<IconProps> = props => (
  <Paperclip {...getIconProps(props)} />
);

export const CheckCheckIcon: React.FC<IconProps> = props => (
  <CheckCheck {...getIconProps(props)} />
);

